var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 44,
    viewBox: "0 0 38 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.7209 7V25.5L38 28C38 22.1667 37.7209 7.3 37.7209 4.5C37.7209 1.7 35.3876 0.666667 34.2209 0.5H3.72095C1.32095 0.5 0.387556 2.83333 0.220861 4C0.054194 13.1667 -0.179139 32.1 0.220861 34.5C0.720861 37.5 3.22086 38.5 4.22086 38.5H22V35H4.72086C4.22095 35 3.22095 35 3.22086 33.5V7H34.7209Z",
    fill: "#3C4977"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1674 31.2273H33.3305C33.7722 31.2273 34.1958 31.0549 34.5081 30.748C34.8204 30.4411 34.9958 30.0249 34.9958 29.5909C34.9958 29.1569 34.8204 28.7407 34.5081 28.4338C34.1958 28.1269 33.7722 27.9545 33.3305 27.9545H31.6653V27.1364C31.6653 26.7024 31.4898 26.2862 31.1775 25.9793C30.8652 25.6724 30.4417 25.5 30 25.5C29.5583 25.5 29.1348 25.6724 28.8225 25.9793C28.5102 26.2862 28.3347 26.7024 28.3347 27.1364V28.0364C27.323 28.2382 26.4236 28.8023 25.8113 29.6192C25.1989 30.436 24.9173 31.4472 25.0211 32.4566C25.1248 33.466 25.6066 34.4014 26.3728 35.0814C27.139 35.7614 28.1349 36.1374 29.1674 36.1364H30.8326C31.0535 36.1364 31.2652 36.2226 31.4214 36.376C31.5775 36.5294 31.6653 36.7376 31.6653 36.9545C31.6653 37.1715 31.5775 37.3797 31.4214 37.5331C31.2652 37.6865 31.0535 37.7727 30.8326 37.7727H26.6695C26.2278 37.7727 25.8042 37.9451 25.4919 38.252C25.1796 38.5589 25.0042 38.9751 25.0042 39.4091C25.0042 39.8431 25.1796 40.2593 25.4919 40.5662C25.8042 40.8731 26.2278 41.0455 26.6695 41.0455H28.3347V41.8636C28.3347 42.2976 28.5102 42.7138 28.8225 43.0207C29.1348 43.3276 29.5583 43.5 30 43.5C30.4417 43.5 30.8652 43.3276 31.1775 43.0207C31.4898 42.7138 31.6653 42.2976 31.6653 41.8636V40.9636C32.677 40.7618 33.5764 40.1977 34.1887 39.3808C34.8011 38.564 35.0827 37.5528 34.9789 36.5434C34.8752 35.534 34.3934 34.5986 33.6272 33.9186C32.861 33.2386 31.8651 32.8626 30.8326 32.8636H29.1674C28.9465 32.8636 28.7348 32.7774 28.5786 32.624C28.4225 32.4706 28.3347 32.2625 28.3347 32.0455C28.3347 31.8285 28.4225 31.6204 28.5786 31.4669C28.7348 31.3135 28.9465 31.2273 29.1674 31.2273Z",
    fill: "#3C4977"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 9.5,
    width: 5,
    height: 5,
    rx: 0.5,
    fill: "#3C4977"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 16.5,
    width: 5,
    height: 5,
    rx: 0.5,
    fill: "#3C4977"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 23.5,
    width: 5,
    height: 5,
    rx: 0.5,
    fill: "#3C4977"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 9.5,
    width: 5,
    height: 5,
    rx: 0.5,
    fill: "#3C4977"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 13.25,
    y: 16.75,
    width: 4.5,
    height: 4.5,
    rx: 0.25,
    stroke: "#3C4977",
    strokeWidth: 0.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 20.25,
    y: 23.75,
    width: 4.5,
    height: 4.5,
    rx: 0.25,
    stroke: "#3C4977",
    strokeWidth: 0.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 9.5,
    width: 5,
    height: 5,
    rx: 0.5,
    fill: "#3C4977"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 16.5,
    width: 5,
    height: 5,
    rx: 0.5,
    fill: "#3C4977"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 23.5,
    width: 5,
    height: 5,
    rx: 0.5,
    fill: "#3C4977"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 9.5,
    width: 5,
    height: 5,
    rx: 0.5,
    fill: "#3C4977"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 16.5,
    width: 5,
    height: 5,
    rx: 0.5,
    fill: "#3C4977"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan);
export default __webpack_public_path__ + "static/media/plan.5c33c69c0da6d894a2d75cc8d6dfad72.svg";
export { ForwardRef as ReactComponent };